import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import QualificationForm from "./pages/QualificationForm";
import ResultsPage from "./pages/ResultsPage";
import FreeResultsPage from "./pages/FreeResultsPage";
import AdminPage from "./pages/AdminPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ContactPage from "./pages/ContactPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import PartnersVerifyPage from "./pages/PartnersVerifyPage";
import PartnersDemoPage from "./pages/PartnersDemoPage";
import PartnerPortalPage from "./pages/PartnerPortalPage";
import LendDemoPage from "./pages/LendDemoPage";
import BookDemoPage from "./pages/BookDemoPage";
import DemoRunnerPage from "./pages/DemoRunnerPage";
import BuyingPowerPage from "./pages/BuyingPowerPage";
import NotFoundPage from "./pages/NotFoundPage";
import HeaderSwitcher from "./components/HeaderSwitcher";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-white">
        <BrowserRouter>
          <HeaderSwitcher />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/qualify" element={<QualificationForm />} />
            <Route path="/free-results" element={<FreeResultsPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/login" element={<AuthPage defaultTab="login" />} />
            <Route path="/signup" element={<AuthPage defaultTab="register" />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<DisclaimerPage />} />
            <Route path="/terms-of-service" element={<DisclaimerPage />} />
            <Route path="/partners/verify" element={<PartnersVerifyPage />} />
            <Route path="/partners/verify/demo" element={<PartnersDemoPage />} />
            <Route path="/partners/portal" element={<PartnerPortalPage />} />
            <Route path="/partners/lend-demo" element={<LendDemoPage />} />
            <Route path="/book-demo" element={<BookDemoPage />} />
            <Route path="/demo/:scenarioId" element={<DemoRunnerPage />} />
            <Route path="/buying-power" element={<BuyingPowerPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
